import { Timestamp } from 'firebase/firestore';

/** Firestore Timestamp | already-ms | pending serverTimestamp → ms number. */
export function toMillis(v: unknown): number {
  if (v instanceof Timestamp) return v.toMillis();
  if (typeof v === 'number') return v;
  return 0;
}
